module.exports = __webpack_public_path__ + "static/media/nephews2.f672a5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/nephews2.png
// module id = 222
// module chunks = 0